/* Section 1: scoped entrance animation; reconnects safely in the theme editor. */
if (!customElements.get('lets-get-real-hero')) {
  customElements.define('lets-get-real-hero', class extends HTMLElement {
    connectedCallback() {
      // Registered elements may connect before their children are parsed.
      this.frame = requestAnimationFrame(() => this.prepare());
    }

    prepare() {
      const hero = this.querySelector('.lgHero');
      if (!hero) return;
      this.observer?.disconnect();
      this.classList.add('is-ready');
      hero.classList.remove('is-in');
      // Commit the initial styles before starting the entrance transitions.
      void hero.offsetHeight;
      const reveal = () => {
        this.observer?.disconnect();
        this.frame = requestAnimationFrame(() => {
          if (this.isConnected) hero.classList.add('is-in');
        });
      };
      if (matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
        reveal();
      } else {
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) reveal();
        });
        this.observer.observe(hero);
      }
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.observer?.disconnect();
      this.classList.remove('is-ready');
    }
  });
  ['shopify:section:load', 'shopify:section:select'].forEach(eventName => {
    document.addEventListener(eventName, event => {
      event.target.querySelectorAll('lets-get-real-hero').forEach(hero => {
        cancelAnimationFrame(hero.frame);
        hero.prepare();
      });
    });
  });
}
